import React, { useState } from 'react';
import { WpPage_Flexiblecontent_FlexibleContent_Faq } from 'src/_generated/types';
import { Section } from '~/components/elements/Section';
import { Icon, IconType } from '../elements/Icon';

export default function Faq({ section, heading, subheading, questions }: WpPage_Flexiblecontent_FlexibleContent_Faq) {
    const half = Math.ceil(questions.length / 2);
    const questions1 = questions.slice(0, half);
    const questions2 = questions.slice(half, questions.length);

    return (
        <Section {...section}>
            <div className={`container `}>
                <div className="mx-auto text-center">
                    <h6 className="text-h6">{subheading}</h6>
                    <h2 className="text-h2 mt-[18px] max-w-[917px] mx-auto">{heading}</h2>
                </div>

                <div className="mt-[42px] md:flex md:flex-row border-t-2 border-gray-300">
                    <div className="md:flex flex-col md:w-1/2 md:pr-5">
                        {renderQuestions(questions1)}
                    </div>
                    <div className="flex flex-col md:w-1/2 md:pl-5">
                        {renderQuestions(questions2)}
                    </div>
                </div>
            </div>
        </Section>
    );
}

function renderQuestions(questions: any[]) {
    const [activeQuestions, setActiveQuestions] = useState<number[]>([]);

    const toggleQuestion = (index: number) => {
        if (activeQuestions.includes(index)) {
            setActiveQuestions(activeQuestions.filter(q => q !== index));
        } else {
            setActiveQuestions([...activeQuestions, index]);
        }
    }

    return questions?.map((q, i) => (
        <div key={`question${i}`} className="border-b-2 border-gray-300">
            <h3 className='text-h5 cursor-pointer flex justify-between pt-6 pb-5' onClick={() => toggleQuestion(i)}>
                {q.question}
                <span>
                    <Icon
                        type={IconType.ArrowDown}
                        classes={`${activeQuestions.includes(i) ? 'text-gray-600 transform rotate-180' : ' text-gray-400'
                            }  'roup-hover:opacity-50
                                transition-transform duration-150 ease-in-out pt-2 mr-1`}
                        aria-hidden="true"
                    /></span>
            </h3>
            <div className={`pb-6 opacity-60 ${activeQuestions.includes(i) ? '' : 'hidden'}`} style={{ alignSelf: 'flex-start' }} dangerouslySetInnerHTML={{ __html: q.answer }}></div>
        </div>
    ));
}
